module.exports = __webpack_public_path__ + "static/img/coming.2fc578d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure/coming.png
// module id = 6Oh7
// module chunks = 1